<div class="terms-container">
    <h1>{{ 'terms.terms_title' | translate }}</h1>
    <ng-container>
        <p [innerHtml]="'terms.terms_conditions' | translate"></p>
    </ng-container>
  
</div>